// extracted by mini-css-extract-plugin
export default {"isNotActive":"LineView_isNotActive--FYR","cursor":"LineView_cursor--TIk","iconsName":"LineView_iconsName--GXo","margin":"LineView_margin--OlO"};